import React from 'react'
import { TimeTravelProvider } from './TimeTravelProvider'
import { CountryProvider } from './CountryProvider'
import { QAPermissionsProvider } from './PermissionsProvider'

const QualityAssuranceProviders = ({ children }) => {
  return (
    <TimeTravelProvider>
      <CountryProvider>
        <QAPermissionsProvider>{children}</QAPermissionsProvider>
      </CountryProvider>
    </TimeTravelProvider>
  )
}

export default QualityAssuranceProviders
